import { memo } from "react";
import { useDispatch, useSelector } from "react-redux";
import Spinner from "../../../common/components/Spinner/Spinner";
import { useOnMount } from "../../../common/hooks/useOnMount";
import { type RootState } from "../../../redux/store";
import { EmptyCartPage } from "../../components/CartPage/EmptyCartPage";
import { B2BCart } from "./components/B2BCart";
import { CartPageContextProvider } from "~/Cart/pages/CartPage/contexts/CartPageContext";
import { cartPageLoadThunk } from "~/Cart/pages/CartPage/redux/cartPageLoadThunk";
import { userIsCustomer } from "~/utils/roles";
import { B2CCart } from "~/Cart/pages/CartPage/B2CCart/B2CCart";
import { FCCGapProductRecommendation } from "../../../feature/SaleRecommendations/FCCRecommendationsSection/SchaefflerFCCGapProductsRecommendationComponent";
import { PurchasePlaceProvider } from "~/feature/Analytics/ga/recommendations/RecommendationContexts";

export const CartPage = memo(() => {
  const dispatch = useDispatch();
  useOnMount(() => {
    dispatch(cartPageLoadThunk());
  });

  const isCartLoading = useSelector(selectIsCartLoading);
  const isCartEmpty = useSelector(selectIsCartEmpty);

  if (isCartLoading) {
    return <Spinner />;
  }

  if (isCartEmpty) {
    return (
      <>
        <EmptyCartPage />
        <FCCGapProductRecommendation />
      </>
    );
  }

  if (!userIsCustomer()) {
    return <B2CCart />;
  }

  return <B2BCart />;
});

const selectIsCartLoading = (state: RootState) => state.cartPage.loading;
const selectIsCartEmpty = (state: RootState) => selectIsCartLoading(state) || state.cart.cartEntries.length === 0;

export interface Props {
  disableCheckout: boolean;
  showSubtotal: boolean;
}

export function createCartPage(props: Props) {
  return (
    <PurchasePlaceProvider value={"CART"}>
      <CartPageContextProvider value={props}>
        <CartPage />
      </CartPageContextProvider>
    </PurchasePlaceProvider>
  );
}
